/**
 * Header Bar — Interaction-only JavaScript
 * All HTML is server-rendered by Liquid. This JS only handles:
 *   - Mobile menu toggle + slide panels
 *   - Mega menu hover (show/hide category panels)
 *   - Dropdown menu hover (open/close with timeout)
 *   - Search popup (open/close/escape)
 */
(function () {
  "use strict";

  // Guard contre les ré-exécutions dans l'éditeur Shopify (shopify:section:load)
  if (window.__vcoHeaderBarInit) return;
  window.__vcoHeaderBarInit = true;

  // ── State ──
  const closeTimeouts = new Map();
  let mobileMenuOpen = false;
  let previousFocusBeforeSearch = null;

  // ── DOM Elements ──
  const mobileToggle = document.getElementById("vco-mobile-toggle");
  const mobileMenu = document.getElementById("vco-mobile-menu");
  const menuIcon = document.getElementById("vco-menu-icon");
  const closeIcon = document.getElementById("vco-close-icon");
  const megaMenu = document.getElementById("vco-mega-menu");

  // ── Helpers ──
  function clearMenuTimeout(el) {
    if (closeTimeouts.has(el)) {
      clearTimeout(closeTimeouts.get(el));
      closeTimeouts.delete(el);
    }
  }

  function setMenuTimeout(el, fn, delay) {
    clearMenuTimeout(el);
    closeTimeouts.set(el, setTimeout(fn, delay));
  }

  function closeMobileMenu() {
    mobileMenuOpen = false;
    if (mobileMenu) mobileMenu.classList.remove("open");
    if (menuIcon) menuIcon.style.display = "block";
    if (closeIcon) closeIcon.style.display = "none";
    if (mobileToggle) {
      mobileToggle.setAttribute("aria-expanded", "false");
    }
    if (mobileMenu) mobileMenu.setAttribute("aria-hidden", "true");
    slideToMain();
  }

  function closeAllMenus() {
    if (megaMenu) megaMenu.classList.remove("open");
    document.querySelectorAll(".vco-dropdown-menu").forEach(function (el) {
      el.classList.remove("open");
    });
    document.querySelectorAll(".vco-nav-chevron").forEach(function (el) {
      el.classList.remove("rotated");
    });
  }

  function setChevron(btn, rotated) {
    if (!btn) return;
    const chevron = btn.querySelector(".vco-nav-chevron");
    if (chevron) chevron.classList.toggle("rotated", rotated);
  }

  // ═══════════════════════════════════
  // MOBILE MENU
  // ═══════════════════════════════════
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function () {
      mobileMenuOpen = !mobileMenuOpen;
      if (mobileMenuOpen) {
        mobileMenu.classList.add("open");
        if (menuIcon) menuIcon.style.display = "none";
        if (closeIcon) closeIcon.style.display = "block";
        mobileToggle.setAttribute("aria-expanded", "true");
        mobileMenu.setAttribute("aria-hidden", "false");
      } else {
        closeMobileMenu();
      }
    });
  }

  // Slide to submenu panel
  document.querySelectorAll("[data-slide-to]").forEach(function (trigger) {
    const link = trigger.querySelector("a");
    trigger.addEventListener("click", function (e) {
      if (e.target === link || (link && link.contains(e.target))) return;
      e.preventDefault();
      e.stopPropagation();
      const menuKey = this.getAttribute("data-slide-to");
      if (!menuKey) return;
      const mainPanel = document.getElementById("vco-mobile-main-panel");
      const subPanel = document.getElementById("vco-mobile-panel-" + menuKey);
      if (mainPanel && subPanel) {
        mainPanel.classList.add("slide-out");
        subPanel.classList.add("active");
      }
    });
  });

  // Back buttons
  function slideToMain() {
    const mainPanel = document.getElementById("vco-mobile-main-panel");
    const activeSubPanel = document.querySelector(".vco-mobile-menu-panel.sub.active");
    if (mainPanel) mainPanel.classList.remove("slide-out");
    if (activeSubPanel) activeSubPanel.classList.remove("active");
  }

  document.querySelectorAll("[data-back-to]").forEach(function (backBtn) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      slideToMain();
    });
  });

  // ═══════════════════════════════════
  // MEGA MENU (Produits) — Category hover
  // ═══════════════════════════════════
  const produitsItem = document.querySelector('[data-menu="produits"]');
  const btnProduits = document.getElementById("btn-produits");
  const categoryBtns = document.querySelectorAll(".vco-category-btn");
  const megaPanels = document.querySelectorAll(".vco-mega-panel");
  const promoPanels = document.querySelectorAll(".vco-promo-panel");

  // Switch category on hover
  categoryBtns.forEach(function (btn) {
    btn.addEventListener("mouseenter", function () {
      const catName = this.getAttribute("data-category");
      categoryBtns.forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");
      megaPanels.forEach(function (panel) {
        panel.style.display = panel.getAttribute("data-panel") === catName ? "" : "none";
      });
      promoPanels.forEach(function (panel) {
        panel.style.display = panel.getAttribute("data-promo") === catName ? "" : "none";
      });
    });
  });

  // Open mega menu on hover
  if (produitsItem && megaMenu) {
    produitsItem.addEventListener("mouseenter", function () {
      clearMenuTimeout(produitsItem);
      clearMenuTimeout(megaMenu);
      closeAllMenus();
      megaMenu.classList.add("open");
      setChevron(btnProduits, true);
    });

    produitsItem.addEventListener("mouseleave", function () {
      setMenuTimeout(produitsItem, function () {
        megaMenu.classList.remove("open");
        setChevron(btnProduits, false);
      }, 50);
    });

    megaMenu.addEventListener("mouseenter", function () {
      clearMenuTimeout(produitsItem);
      clearMenuTimeout(megaMenu);
    });

    megaMenu.addEventListener("mouseleave", function () {
      setMenuTimeout(megaMenu, function () {
        megaMenu.classList.remove("open");
        setChevron(btnProduits, false);
      }, 50);
    });
  }

  // ═══════════════════════════════════
  // DROPDOWN MENUS (Thèmes, Bestseller, etc.)
  // ═══════════════════════════════════
  document.querySelectorAll(".vco-nav-item").forEach(function (navItem) {
    const menuKey = navItem.getAttribute("data-menu");
    if (!menuKey || menuKey === "produits") return;

    const dropdown = document.getElementById("vco-dropdown-" + menuKey);
    const btn = document.getElementById("btn-" + menuKey);
    if (!dropdown || !btn) return;

    navItem.addEventListener("mouseenter", function () {
      clearMenuTimeout(navItem);
      clearMenuTimeout(dropdown);
      closeAllMenus();
      dropdown.classList.add("open");
      setChevron(btn, true);
    });

    navItem.addEventListener("mouseleave", function () {
      setMenuTimeout(navItem, function () {
        dropdown.classList.remove("open");
        setChevron(btn, false);
      }, 50);
    });

    dropdown.addEventListener("mouseenter", function () {
      clearMenuTimeout(navItem);
      clearMenuTimeout(dropdown);
    });

    dropdown.addEventListener("mouseleave", function () {
      setMenuTimeout(dropdown, function () {
        dropdown.classList.remove("open");
        setChevron(btn, false);
      }, 50);
    });
  });

  // ═══════════════════════════════════
  // SEARCH POPUP
  // ═══════════════════════════════════
  const searchPopup = document.getElementById("vco-search-popup");
  const searchPopupClose = document.getElementById("vco-search-popup-close");
  const searchPopupInput = document.getElementById("vco-search-popup-input");
  const searchInputs = document.querySelectorAll(".vco-search-input");

  function openSearchPopup() {
    if (!searchPopup) return;
    previousFocusBeforeSearch = document.activeElement;
    searchPopup.classList.add("open");
    document.body.classList.add("search-open");
    if (searchPopupInput) searchPopupInput.focus();
  }

  function closeSearchPopup() {
    if (!searchPopup) return;
    searchPopup.classList.remove("open");
    document.body.classList.remove("search-open");
    if (previousFocusBeforeSearch && document.body.contains(previousFocusBeforeSearch)) {
      previousFocusBeforeSearch.focus();
    }
    previousFocusBeforeSearch = null;
  }

  searchInputs.forEach(function (input) {
    input.addEventListener("click", function (e) {
      e.preventDefault();
      openSearchPopup();
    });
  });

  if (searchPopupClose) {
    searchPopupClose.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearchPopup();
    });
  }

  if (searchPopup) {
    searchPopup.addEventListener("click", function (e) {
      if (e.target === searchPopup) closeSearchPopup();
    });
  }

  function onKeyDown(e) {
    if (e.key === "Escape" && searchPopup && searchPopup.classList.contains("open")) {
      closeSearchPopup();
    }
  }
  document.addEventListener("keydown", onKeyDown);

})();
